import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

// ** Axios Imports
import axios from "src/utils/AxiosConfig";

export const getUserProfiles = createAsyncThunk(
  "appUsers/fetchUserProfiles",
  async (params, { getState, dispatch, rejectWithValue }) => {
    try {
      const response = await axios.get("/api/profile");
      return response.data; 
    } catch (error) {
      console.error("Profile retrieval error:", error.response?.data || error);
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const addUserProfile = createAsyncThunk(
  "appUsers/addUserProfile",
  async (data, { getState, dispatch, rejectWithValue }) => {
    try {
      const response = await axios.post("/api/profile", data);
      return response.data;
    } catch (error) {
      console.error("Profile creation error:", error.response?.data || error);
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const updateUserProfile = createAsyncThunk(
  "appUsers/updateUserProfile",
  async (data, { getState, dispatch, rejectWithValue }) => {
    try {
      const response = await axios.put(`/api/profile/${data.user_id}`, data);
      return response.data;
    } catch (error) {
      console.error("Profile update error:", error.response?.data || error);
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const deleteUserProfile = createAsyncThunk(
  "appUsers/deleteUserProfile",
  async (userId, { getState, dispatch, rejectWithValue}) => {
    try {
      const response = await axios.delete(`/api/profile/${userId}`);
      return response.data;
    }
    catch (error) {
      console.error("profile deletion error:",error.response?.data || error);
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
)

export const getUserProfile = createAsyncThunk(
  "appUsers/getUserProfile",
  async (userId, { getState, dispatch, rejectWithValue }) => {
    try {
      const response = await axios.get(`/api/profile/${userId}`);
      return response.data;
    } catch (error) {
      console.error("Profile retrieval error:", error.response?.data || error);
      return rejectWithValue(
        error.response ? error.response.data : error.message
      );
    }
  }
);

export const appProfileSlice = createSlice({
  name: "appProfile",
  initialState: {
    profile: {
      data: null,
      status: "idle",
      message: null,
      errors: null,
    },
  },
  reducers: {
    resetProfile: (state) => {
      state.profile = {
        data: null,
        status: "idle",
        message: null,
        errors: null,
      };
    },
  },
  extraReducers: (builder) => {
    // Add User Profile
    builder
      .addCase(addUserProfile.pending, (state) => {
        state.profile.status = "loading";
        state.profile.message = null;
        state.profile.errors = null;
      })
      .addCase(addUserProfile.fulfilled, (state, action) => {
        state.profile.status = "succeeded";
        state.profile.data = action.payload.data;
      })
      .addCase(addUserProfile.rejected, (state, action) => {
        state.profile.status = "failed";
        state.profile.message = action.payload?.message;
        state.profile.errors = action.payload?.errors;
      });

    // Update User Profile
    builder
      .addCase(updateUserProfile.pending, (state) => {
        state.profile.status = "loading";
        state.profile.message = null;
        state.profile.errors = null;
      })
      .addCase(updateUserProfile.fulfilled, (state, action) => {
        state.profile.status = "succeeded";
        state.profile.data = action.payload.data;
      })
      .addCase(updateUserProfile.rejected, (state, action) => {
        state.profile.status = "failed";
        state.profile.message = action.payload?.message;
        state.profile.errors = action.payload?.errors;
      });

    // Get User Profile
    builder
      .addCase(getUserProfile.pending, (state) => {
        state.profile.status = "loading";
        state.profile.message = null;
        state.profile.errors = null;
      })
      .addCase(getUserProfile.fulfilled, (state, action) => {
        state.profile.status = "succeeded";
        state.profile.data = action.payload.data;
      })
      .addCase(getUserProfile.rejected, (state, action) => {
        state.profile.status = "failed";
        state.profile.message = action.payload?.message;
        state.profile.errors = action.payload?.errors;
      });
    
      builder
      .addCase(deleteUserProfile.pending, (state) => {
        state.profile.status = "loading";
        state.profile.message = null;
        state.profile.errors = null;
      })
      .addCase(deleteUserProfile.fulfilled, (state, action) => {
        state.profile.status = "succeeded";
        state.profile.data = action.payload.data;
      })
      .addCase(deleteUserProfile.rejected, (state, action) => {
        state.profile.status = "failed";
        state.profile.message = action.payload?.message;
        state.profile.errors = action.payload?.errors;
      });
    builder
      .addCase(getUserProfiles.pending, (state) => {
        state.profile.status = "loading";
        state.profile.message = null;
        state.profile.errors = null;
      })
      .addCase(getUserProfiles.fulfilled, (state, action) => {
        state.profile.status = "succeeded";
        state.profile.data = action.payload.data;
      })
      .addCase(getUserProfiles.rejected, (state, action) => {
        state.profile.status = "failed";
        state.profile.message = action.payload?.message;
        state.profile.errors = action.payload?.errors;
      });
  },
});

export const { resetProfile } = appProfileSlice.actions;

export default appProfileSlice.reducer;
